/**
 * @generated SignedSource<<a2e690b388b8d2b006424bd811194267>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TabWithMenu_tab$data = {
  readonly __typename: string;
  readonly id: string;
  readonly label: string;
  readonly " $fragmentSpreads": FragmentRefs<"TabMenu_tab">;
  readonly " $fragmentType": "TabWithMenu_tab";
};
export type TabWithMenu_tab$key = {
  readonly " $data"?: TabWithMenu_tab$data;
  readonly " $fragmentSpreads": FragmentRefs<"TabWithMenu_tab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "TabWithMenu_tab",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "label"
      },
      "action": "THROW",
      "path": "label"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "FragmentSpread",
      "name": "TabMenu_tab"
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
};

(node as any).hash = "3e6f0729f3e809e978899462ea283562";

export default node;
